import React, { Component } from 'react';

class mainNav extends Component {

  render() {
    return (
        <nav className="main-nav">
        <a href="#lead-the-way" className="lead-the-way">Lead The Way</a>
        <a href="#the-change" className="the-change">Be The Change</a>
        <a href="#the-influence" className="the-influence">The influence</a>
        <a href="#get-support" className="get-support">Get Support</a>
        </nav>
    );
  }
}

export default mainNav;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/MainNav/MainNav.js